/* Decides when the sticky add-to-cart bar may show, and tells the page when it is showing.

   There are two reasons to hide the bar.

   1. The reader has not picked a size. option-value.liquid never marks a size radio checked on
      load, on purpose. The form still falls back to the first variant, so the button would add XS
      without asking.
   2. The size the reader picked is sold out. The bar renders behind `{% if product.available %}`,
      which is whole-product availability. That stays true while any one size is in stock.

   Both answers live in the browser. The page does not render again when the reader picks a size,
   so the server cannot decide either one.

   The two reasons get their own class on purpose. If marketing later wants the bar to carry its
   own size selector, the bar has to stay visible while the size is still missing. Then you delete
   the is-option-incomplete rule in theme.css and keep everything else.

   The script also puts a class and the bar's height on <html>. theme.css uses them to keep keyboard
   focus from hiding behind the bar, and to leave room at the page end for the last footer row. */
(function () {
  var INCOMPLETE = 'is-option-incomplete';
  var UNAVAILABLE = 'is-variant-unavailable';
  var SHOWING = 'sticky-atc-visible';

  /* True once every option group holds a checked input. Groups inside the bar are skipped, so a
     size selector added to the bar later cannot answer its own question. */
  function optionsComplete(scope, bar) {
    var groups = scope.querySelectorAll('[data-option-selector]');
    for (var i = 0; i < groups.length; i++) {
      if (bar.contains(groups[i])) continue;
      if (!groups[i].querySelector('input:checked')) return false;
    }
    return true;
  }

  /* The theme keeps this button in step. BuyButtons in assets/theme.js sets disabled from the
     variant on every variant:change, and the server renders it correctly on load. Reading it back
     beats tracking the variant here, and it survives the AJAX swap on a print switch. */
  function variantAvailable(bar) {
    var button = bar.querySelector('button[type="submit"]');
    return !!button && !button.disabled;
  }

  function apply() {
    var bars = document.querySelectorAll('.product-sticky-bar');
    var root = document.documentElement;
    var showing = false;
    var height = 0;

    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var scope = bar.closest('product-info') || bar.closest('.shopify-section') || document;

      bar.classList.toggle(INCOMPLETE, !optionsComplete(scope, bar));
      bar.classList.toggle(UNAVAILABLE, !variantAvailable(bar));

      /* Measured after the classes change, so a bar that just went away reads 0. CSS owns the
         width rule, so above 700px the bar is display:none and this is 0 there too. That keeps one
         source of truth for the breakpoint. */
      var box = bar.getBoundingClientRect();
      if (box.height > height) height = box.height;
      if (box.height > 0) showing = true;
    }

    root.classList.toggle(SHOWING, showing);
    root.style.setProperty('--sticky-atc-height', height + 'px');
  }

  /* change covers a size click. variant:change covers the theme settling afterwards.
     product-info:rendered covers the print switch, which replaces the bar and its classes with
     fresh markup. resize covers crossing the 700px breakpoint, where the bar stops existing.
     All of these bubble to the document, so one listener each outlives the swap. */
  document.addEventListener('change', apply);
  document.addEventListener('variant:change', apply);
  document.addEventListener('product-info:rendered', apply);
  window.addEventListener('resize', apply);

  /* Keyboard focus must not hide behind the bar (WCAG 2.4.11). theme.css sets scroll-padding-bottom,
     and Chrome uses it. Firefox does not scroll when focus moves to an element that is already on
     screen, so the element can still sit behind the bar. Then move the page up by the overlap.
     Keyboard focus only. A tap needs no help, and the page should not move under a finger. */
  document.addEventListener('focusin', function (event) {
    if (!document.documentElement.classList.contains(SHOWING)) return;
    var target = event.target;
    if (!target.matches(':focus-visible')) return;
    var bars = document.querySelectorAll('.product-sticky-bar');
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i].getBoundingClientRect();
      if (!bar.height || bars[i].contains(target)) continue;
      var box = target.getBoundingClientRect();
      if (box.height && box.bottom > bar.top && box.top < bar.bottom) {
        window.scrollBy({ top: box.bottom - bar.top + 12, behavior: 'instant' });
      }
      return;
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
